/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $ = jQuery;
	
	var DiscGolfMetrixSettings = function DiscGolfMetrixSettings() {
	  var _this = this;
	
	  _classCallCheck(this, DiscGolfMetrixSettings);
	
	  this.onFiltersUpdate = function (evt, ui) {
	    var filtersSelected = _this.$filtersSelected.children().map(function (idx, el) {
	      return $(el).data('name');
	    }).toArray();
	
	    console.log(filtersSelected);
	    _this.$filtersSelectedInput.val(JSON.stringify(filtersSelected));
	  };
	
	  this.$filtersSelected = $('.filters-selected');
	  this.$filtersSelectedInput = $('input[name="discgolfmetrix_options[results_filter]"]');
	
	  $('.discgolfmetrix-results-filter').sortable({
	    connectWith: '.discgolfmetrix-results-filter'
	  });
	
	  this.$filtersSelected.on('sortupdate', this.onFiltersUpdate);
	};
	
	new DiscGolfMetrixSettings();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// discgolfmetrix-settings.js